import styled from "styled-components";

const PromoteMemberContainer = styled.div`
  /* margin-left: 30px; */
 
`;

export default PromoteMemberContainer;